export default {
  name: '学员',
  permissionsKey: "JG-XY",
  icon: 'fa fa-address-book',
  children: {
    studentList: {
      name: '学员列表',
      permissionsKey: "JG-XY-XYLB",
      path: '/student_manage/student_list',
    },
    dataReport: {
      name: '数据导出',
      permissionsKey: "JG-XY-SJDC",
      path: '/student_manage/data_report',
    },
    // classList: {
    //   name: '班级列表',
    //   permissionsKey: "",
    //   path: '/student_manage/class_list',
    // },
    // progressList : {
    //   name: '学习进度',
    //   permissionsKey:"",
    //   path: '/student_manage/progress_list',
    // },
    // grouping : {
    //   name: '分组',
    //   permissionsKey:"",
    //   path: '/student_manage/grouping',
    // },
  }
};
